import Actions from 'actions'
import { useCallback, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

export default () => {
  const dispatch = useDispatch()

  const { data: grinGroups, isLoading } = useSelector(state => state.supportReducer.userGroups)

  useEffect(() => {
    if (!grinGroups?.length) {
      dispatch(Actions.fetchUserGroups())
    }
  }, [grinGroups, dispatch])

  const hiGroups = useMemo(
    () =>
      (grinGroups || []).filter(group => {
        const extraData = JSON.parse(group?.extraData || '{}')
        return extraData.isHI
      }),
    [grinGroups]
  )

  const getHiGroupDisplayName = useCallback(
    hiGroupKey => {
      const hiGroup = hiGroups.find(group => group.key === hiGroupKey)
      return hiGroup?.displayName || hiGroupKey || ''
    },
    [hiGroups]
  )

  return {
    isLoading,
    grinGroups,
    hiGroups,
    getHiGroupDisplayName
  }
}
